import { dataHook, getPolicyLink } from '../../utils'
import classes from './cookie-policy-link.css'

export const LINK_HOOK = 'cookie-policy-link'

export const createCookiePolicyLinkTemplate = (
  label: string,
  wixPolicyLink: string,
  editorxPolicyLink: string,
) =>
  `<a class="${classes.link}" ${dataHook(LINK_HOOK)} href="${getPolicyLink(
    wixPolicyLink,
    editorxPolicyLink,
  )}" target="_blank">${label}</a>`
